const calculatorConfigData= {
  "Units": [
    {
      "name": "ChillerCapacity",
      "id": "1",
      "unitList": [
        {
          "name": "Tons",
          "code": "24",
          "value": "",
          "decimalPoints": 1,
          "id": "1"
        },
        {
          "name": "kW",
          "code": "68",
          "value": "",
          "decimalPoints": 1,
          "id": "2"
        }
      ]
    },
    {
      "name": "FliudFlowRate",
      "id": "2",
      "unitList": [
        {
          "name": "gpm",
          "code": "14",
          "value": "",
          "decimalPoints": 1,
          "id": "3"
        },
        {
          "name": "L/s",
          "code": "73",
          "value": "",
          "decimalPoints": 2,
          "id": "4"
        }
      ]
    },
    {
      "name": "Temperature",
      "id": "3",
      "unitList": [
        {
          "name": "°F",
          "code": "38",
          "value": "",
          "id": "5",
          "decimalPoints": 2
        },
        {
          "name": "°C",
          "code": "85",
          "value": "",
          "id": "6",
          "decimalPoints": 2
        }
      ]
    },
    {
      "name": "FluidFlowRateCapacity",
      "id": "4",
      "unitList": [
        {
          "name": "gpm/Ton",
          "code": "17",
          "value": "",
          "id": "7",
          "decimalPoints": 3
        },
        {
          "name": "L/(s-kW)",
          "code": "74",
          "value": "",
          "id": "8",
          "decimalPoints": 5
        }
      ]
    },
    {
      "name": "FoulingFactor",
      "id": "5",
      "unitList": [
        {
          "name": "(hr-sqft-°F)/BTU",
          "code": "43",
          "value": "",
          "id": "9",
          "decimalPoints": 5
        },
        {
          "name": "(sqm-°K)/kW",
          "code": "96",
          "value": "",
          "id": "10",
          "decimalPoints": 5
        }
      ]
    },
    {
      "name": "PS_FLUID_PRESSURE_DROP",
      "id": "6",
      "unitList": [
        {
          "name": 'ft H2O',
          "code": "34",
          "value": "",
          "id": "11",
          "decimalPoints": 1
        },
        {
          "name": "kPa",
          "code": "71",
          "value": "",
          "id": "12",
          "decimalPoints": 1
        }
      ]
    },
    {
      "name": "InputPowerChillerEfficiency",
      "id": "7",
      "unitList": [
        {
          "name": "kW/Ton",
          "code": "68",
          "value": "",
          "id": "13",
          "decimalPoints": 4
        },
        {
          "name": "ikW/kW",
          "code": "24",
          "value": "",
          "id": "14",
          "decimalPoints": 4
        },
        {
          "name": "COP",
          "code": "72",
          "value": "",
          "id": "15",
          "decimalPoints": 3
        },
        {
          "name": "EER",
          "code": "3",
          "value": "",
          "id": "16",
          "decimalPoints": 3
        }
      ]
    }
  ]
}
export default calculatorConfigData;
